import { Divider } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import { Container, Grid } from "@mui/material";
import axios from "axios";
import {
  ButtonGroupTop,
  CustomTable,
  ModalError,
  ModalSuccess,
  Page,
  PrimaryButton,
  SectionLabel,
} from "components";
import { HeaderTitle } from "layouts";
import { getTotalPage } from "lib";
import { useEffect, useState } from "react";
import { hardBaseUrl } from "services/urlConstant";
import { globalStyles } from "styles";
import { getErrors, stringTruncate } from "utils";
import ModalFormCurrency from "./Components/ModalFormCurrency";

function Currency() {
  const classes = globalStyles();
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const [loadingPage, setLoadingPage] = useState(true);
  const [dataTable, setDataTable] = useState([]);
  const [queryParams, setQueryParams] = useState({
    page: 1,
    per_page: 10,
    search: "",
  });
  const [tableTotalPage, setTableTotalPage] = useState(1);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalPreload, setModalPreload] = useState(null);

  const handleChangeQueryParams = (value, key) => {
    setQueryParams(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
  };

  const getDataTable = async () => {
    try {
      setLoadingPage(true);
      const res = await axios.get(`${hardBaseUrl}/currency/datatable`, {
        headers,
        params: queryParams,
      });
      const { data, meta } = res?.data;
      setDataTable(data || []);
      const pageCount = getTotalPage(meta?.total, queryParams?.per_page);
      setTableTotalPage(pageCount || 1);
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };
  const handleDelete = async item => {
    try {
      setLoadingPage(true);
      await axios.delete(`${hardBaseUrl}/currency/delete/${item?.id}`, {
        headers,
      });
      ModalSuccess("Successfully delete currency").then(() => getDataTable());
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };

  useEffect(() => {
    getDataTable();
  }, [queryParams]);

  return (
    <Page className={classes.root} title="Currency">
      <Container maxWidth={false}>
        <HeaderTitle title="Parameter" breadcrumbData={breadcrumbData} />
        <ButtonGroupTop />
        <Divider className={classes?.flatDivider} />
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          my="16px"
        >
          <Grid item>
            <SectionLabel
              title="Currency"
              subTitle="Feature to add currency information"
            />
          </Grid>
          <Grid item>
            <PrimaryButton
              label="Add Currency"
              onClick={() => {
                setModalVisible(true);
                setModalPreload(null);
              }}
              startIcon={<Add />}
              size="large"
              disabled={loadingPage}
            />
          </Grid>
        </Grid>
        <CustomTable
          isLoading={loadingPage}
          columnTable={columnTable}
          data={dataTable}
          page={queryParams?.page}
          pageSize={queryParams?.per_page}
          pageCount={tableTotalPage}
          handleChangePage={(_, page) => handleChangeQueryParams(page, "page")}
          handleChangePageSize={e =>
            handleChangeQueryParams(e?.target?.value, "per_page ")
          }
          isHaveAction
          handleEdit={item => {
            setModalVisible(true);
            setModalPreload(item?.id);
          }}
          tooltipEdit="Update"
          deleteConfirmation
          handleDelete={item => handleDelete(item)}
          deleteConfirmationTitle="Remove Currency"
          deleteConfirmationKey="currency_name"
          tooltipDelete="Remove Currency"
        />
      </Container>
      {modalVisible && (
        <ModalFormCurrency
          open={modalVisible}
          onClose={() => setModalVisible(false)}
          preload={modalPreload}
          getDataTable={getDataTable}
        />
      )}
    </Page>
  );
}

const breadcrumbData = [
  {
    label: "Parameter",
    link: "/admin/parameter/admin-currency",
  },
  {
    label: "Currency",
    active: true,
  },
];
const columnTable = [
  {
    name: "currency_iso_code",
    title: "ISO Code",
  },
  {
    name: "currency_name",
    title: "Name",
  },
  {
    name: "currency_symbol_code",
    title: "Symbol",
  },
  {
    name: "description",
    title: "Description",
    renderText: item => stringTruncate(item, 50) || "-",
  },
];

export default Currency;
